<template>
  <div>
    <ValidationProvider :rules="rules" v-slot="{ valid, errors }">
      <div v-show="false">
        <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" :accept="accept" />
        <input type="text" v-model="fileInputValidation" v-show="false" />
      </div>
      <div class="label_PFormInputFile" v-if="label != ''">{{ label }}</div>
      <div class="container_PFormInputFile" @click="click">
        <div class="textIcon_PFormInputFile">
          <div>
            {{ textUpload }}
          </div>
          <PIcon icon="IconUpload" size="20"></PIcon>
        </div>
      </div>
      <div
        class="p_form_invalid_feedback"
        v-if="!(errors[0] ? false : valid ? true : null) && invalid_feedback != ''"
      >
        {{ invalid_feedback }}
      </div>
      <div
        class="p_form_invalid_feedback"
        v-if="!(errors[0] ? false : valid ? true : null) && invalid_feedback === ''"
      >
        {{ $t(errors[0]) }}
      </div>
    </ValidationProvider>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export class PFormInputFile extends Vue {
  @Prop({ required: true }) value!: File;
  @Prop({ required: false }) accept!: string;
  @Prop({ required: false, default: "" }) label!: string;
  @Prop({ required: false, default: "Selecionar fichero" }) placeholder!: string;
  @Prop({ required: false, default: undefined }) rules!: string;
  @Prop({ required: false, default: "" }) invalid_feedback!: string;
  file: any = "";
  fileInputValidation = "";
  click(): void {
    (this.$refs.file as any).click();
  }
  handleFileUpload(): void {
    this.file = (this.$refs.file as any).files[0];
    this.fileInputValidation = this.file.name;
    this.$emit("input", this.file);
    this.$nextTick(() => {
      //esto es para que funcione la validacion
      this.$emit("change", this.file);
    });
  }
  get textUpload(): string {
    return this.file?.name || this.placeholder;
  }
}
export default PFormInputFile;
</script>
<style scoped>
.label_PFormInputFile {
  line-height: 1.23;
  color: #6f6f6f;
  min-height: 16px;
  padding-bottom: 0.5rem;
  font-size: 12px;
}
.container_PFormInputFile {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 45px;
  border-radius: 4px;
  border: solid 1px #e4e4e4;
  background-color: #fafafa;
  color: #6f6f6f;
  padding: 0 0.45rem 0 1rem;
}
.textIcon_PFormInputFile {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.p_form_invalid_feedback {
  color: #dc3545;
  font-size: 0.7rem;
}
</style>
